<template>
  <div>
    <ul>
      <template v-for="(item, index) in courseList">
        <li class="course-item" v-bind:key="index" v-on:click="courseIndexTap(index)">
          <div class="cover">
            <img v-bind:src="item.cover | coverFilter" alt="" />
          </div>
          <div class="mright">
            <div class="name m-text-ellipsis">{{item.courseName}}</div>
            <div class="introduce">{{item.introduce}}</div>
            <div style="margin: 15px 0px 0px 0px;display:flex">
              <span class="tet-a">学习进度: </span>
              <el-progress :percentage="item.learnSche" :format="format" style="width:300px"></el-progress>
            </div>       
          </div>
        </li>
      </template>
    </ul>
    <el-pagination class="mb-pagination" :current-page="curPage" layout="total, prev, pager, next" :total="total"
      @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>

<script>
  export default {
    name: "StudentCourse",
    components: {},
    data () {
      return {
        courseList: [],
        total: 0,
        curPage: 1,
        learnSche:null,
      };
    },
    filters: {
      coverFilter (cover) {
        return process.env.VUE_APP_imagePath + cover;
      }
    },
    mounted () {
      this.userCourseList(this, this.curPage);
    },
    methods: {
      userCourseList (that, curPage) {
        that.HttpConnection.get("/learn/usercourse/userlist", {
          params: {
            pageNum: curPage,
            pageSize: 10
          }
        }).then(function (response) {
          that.courseList = response.rows;
          that.courseList.filter(item => {
            item.learnSche = Number(item.learnSche);
          })
          that.total = response.total;
        });
      },
      courseIndexTap (index) {
        let that = this;
        let _courseId = that.courseList[index].courseId;
        that.HttpConnection.put("/course/course/learnCount/" + _courseId).then(function (response) {
          that.$router.push({
            path: "/CourseChapter",
            query: {
              courseId: _courseId
            }
          });
        });
      },
      handleCurrentChange (val) {
        this.curPage = val;
        this.userCourseList(this, val);
      },
      // 格式化
      format(percentage){
        return percentage === 100 ? '已完成' : `${percentage}%`;
      }
    }
  };
</script>

<style scoped lang="scss">
  $bgc: #f5f7fa;
  $commonColor: #20a0ff;

  .course-item {
    display: flex;
    flex-direction: row;
    margin: 0px 0px 20px 0px;
    border: 1px solid #ffffff;
    cursor: pointer;
  }

  .course-item:hover {
    background-color: #fafcff;
    border: 1px solid #f5f7fa;

    .name {
      color: #1e6af1;
    }
  }

  .mright {
    width: 708px;
    height: 142px;
    padding: 15px 10px 15px 20px;
  }

  .cover {
    width: 220px;
    height: 144px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }

  .name {
    font-weight: bold;
    color: #333333;
  }

  .introduce {
    height: 40px;
    font-size: 14px;
    color: #93999f;
    margin: 15px 0px 0px 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .tet-a {
    font-size: 14px;
    color: #93999f;
    margin: 0px 10px 0px 0px;
  }

  .icon-a {
    width: 30px;
    height: 30px;
  }

  .vater{
    width: 100%;
    height: 20px;
  }
</style>